import { Grid, Link } from '@mui/material';

const HaveAccount = () => (
  <Grid
    item
    sx={{
      fontSize: '12px',
      mt: 4,
    }}
  >
    Do you already have an account?&nbsp;
    <Link href="/">
      Sign In
    </Link>
  </Grid>
)

export default HaveAccount;
